import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddChannelCommunityDialogComponent } from '../add-channel-community-dialog/add-channel-community-dialog.component';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription, timestamp } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { PubNubService } from 'src/app/core/services/pubnub.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { formatDate } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { API, CURRENCY_SYMBOLS } from 'src/app/core/constants';
import { COLORLIST } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/core/services/user.service';
import { CommunityTipsComponent } from '../community-tips/community-tips.component';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { applyMessageEdit, EDIT_ACTION_TYPE } from 'src/app/core/utils/message-edit.util';
declare let $: any;

@Component({
  selector: 'app-community-maincontent',
  templateUrl: './community-maincontent.component.html',
  styleUrls: ['./community-maincontent.component.scss'],
})
export class CommunityMaincontentComponent implements OnInit {
  // Image preview
  showImagePreview = false;
  previewImageUrl = '';
  previewFilename = '';
  currentImageIndex = -1;
  currentMessageImages: string[] = [];
  currentMessage: any = null;
  scale = 1;
  isFullscreen = false;
  originalBodyOverflow = '';
  blockedUsersData: any[];

  favChannelIds: any[] = [];

  // Method to open image preview
  openImagePreview(imageUrl: string, message: any) {
    this.currentMessage = message;
    this.currentMessageImages = message.files.filter((f: any) => f.type === 'image').map((f: any) => f.url);
    this.currentImageIndex = this.currentMessageImages.indexOf(imageUrl);
    this.previewImageUrl = imageUrl;
    this.previewFilename = this.extractFilenameFromUrl(imageUrl);
    this.showImagePreview = true;
    this.scale = 1;
    this.isFullscreen = false;
    this.originalBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  // Method to close image preview
  closeImagePreview() {
    this.showImagePreview = false;
    document.body.style.overflow = this.originalBodyOverflow;
  }

  // Navigate to next/previous image
  navigateImage(direction: number) {
    this.currentImageIndex = (this.currentImageIndex + direction + this.currentMessageImages.length) % this.currentMessageImages.length;
    this.previewImageUrl = this.currentMessageImages[this.currentImageIndex];
    this.previewFilename = this.extractFilenameFromUrl(this.previewImageUrl);
    this.scale = 1; // Reset zoom when changing images
  }

  // Zoom in/out
  zoomImage(zoomIn: boolean) {
    this.scale = zoomIn ? Math.min(this.scale + 0.25, 3) : Math.max(this.scale - 0.25, 0.5);
  }

  // Reset zoom to 100%
  resetZoom() {
    this.scale = 1;
  }

  // Toggle fullscreen
  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
    if (this.isFullscreen) {
      document.documentElement.requestFullscreen().catch(e => console.log(e));
    } else if (document.fullscreenElement) {
      document.exitFullscreen().catch(e => console.log(e));
    }
  }

  // Extract filename from URL
  private extractFilenameFromUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/');
      const lastPart = pathParts[pathParts.length - 1];
      if (lastPart && lastPart.includes('.')) {
        return lastPart.split('?')[0]; // Remove query parameters if any
      }
    } catch (e) {
      console.error('Error parsing URL:', e);
    }
    return `image-${new Date().getTime()}.jpg`;
  }

  // Download current image
  async downloadImage() {
    try {
      // Extract the filename from the URL or use a default name
      const url = new URL(this.previewImageUrl);
      const pathParts = url.pathname.split('/');
      let filename = `image-${new Date().getTime()}.jpg`;

      // Try to get the original filename from the URL
      const lastPart = pathParts[pathParts.length - 1];
      if (lastPart && lastPart.includes('.')) {
        filename = lastPart.split('?')[0]; // Remove query parameters if any
      }

      // Fetch the image as a blob
      const response = await fetch(this.previewImageUrl, {
        method: 'GET',
        headers: { 'Cache-Control': 'no-cache' },
        credentials: 'same-origin' // Include cookies for authenticated requests
      });

      if (!response.ok) {
        throw new Error(`Failed to download image: ${response.statusText}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.style.display = 'none';

      // Append to body, click to download, then remove
      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);

    } catch (error) {
      console.error('Error downloading image:', error);
      // Fallback to the original method if fetch fails
      const link = document.createElement('a');
      link.href = this.previewImageUrl;
      link.download = `image-${new Date().getTime()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  @ViewChild('sidenav') sidenav!: MatSidenav;
  selectedMsg: any;
  channelId!: string;
  selectedThreadMsg: any;
  displayEmojiPicker: boolean = true;
  emojiMsgId: number | null = null;
  channelUrl: string = "";
  channelDetails: any;
  isChannelAvailable: boolean = false;
  isCheckingChannel: boolean = false;
  communityChannel: any;
  userInfo: any = {};
  organizationId: any;
  favData: any = [];
  userInfoSubscription: Subscription;
  multiEventSubscr: Subscription;
  currentUserId: any;
  countUserColor = 0;
  userColor: any = {};
  settingsData: any = {};
  org_info: any;
  settingsDataSubscription: Subscription;
  orgIdSubscription: Subscription;
  orgInfoSubscription: Subscription;
  messagesList: any[] = [];
  hoveredMsgId: string | null = null;
  userInput: any = '';
  threadInput: any = '';
  selectedFiles: any = [];
  actions: any = [];
  threadSelectedFiles: any = [];
  hoveredReaction: any;
  reactionUsers: { userId: number; nickname: string }[] = [];
  isEmojiInputVisible: boolean = false;
  isThreadEmojiInputVisible = false;
  filteredTeamMembers: any[] = []
  searchChannel: string = "";
  threadMessage: any;
  isFavourite: boolean = false;
  lastReadTimetoken: any;
  favChannelRecordId: any;
  showChat: boolean = true;
  clientDetails: any = environment.clientDetails;
  @ViewChild("messageInput") messageInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild("threadMessageInput")
  threadMessageInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('scrollElement') scrollElement!: ElementRef;
  scrollTimeout: any;
  threadChannelUrl: string;
  channelsUrlsList: any[] = [];
  isBlockedChannel: boolean = true;
  isJoinedChannel: any;
  isStarredChannel: any;
  joinedChannelIds: any[] = [];
  joinedChannelNames: any[] = [];
  joinedChannelsSub!: Subscription;
  athletesData: string[] = [];

  constructor(private pubnubService: PubNubService,
    private matDialog: MatDialog,
    private toastr: ToastrService,
    private commanSubscribeService: CommanSubscribeService,
    private appPaymentService: AppPaymentTVService,
    public router: Router, private appTVService: AppService, private loader: NgxUiLoaderService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef
    , private dialog: MatDialog, private userService: UserService) {
    // this.getFavouriteChannelsInMainContent();
    // this.joinedChannelsSub=this.pubnubService.joinedChannels$.subscribe(memberships => {
    //   this.joinedChannelNames = memberships.map((m: any) => m.channel.name);
    //   console.log("this.joinedChannelNames1",this.joinedChannelNames)
    // });
  }
  async ngOnInit() {
    this.pubnubService.init();

    this.userInfo = this.commanSubscribeService.userInfo;
    this.currentUserId = 'fan_' + this.userInfo.id;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.currentUserId = 'fan_' + this.userInfo.id;
    });

    // connect() is the only place that checks token expiry and refreshes if
    // needed - it used to only run 3 seconds later, inside
    // connectReportChannels()'s setTimeout below, by which point every call
    // in this method had already fired using whatever token was cached,
    // stale or not. Running it first (and waiting for it) means every
    // PubNub call below always has a fresh token.
    await new Promise<void>(resolve => {
      this.pubnubService.connect(this.currentUserId, () => resolve());
    });

    const memberships = ('fan_' + this.userInfo.id) ? await this.pubnubService.getMemberships('fan_' + this.userInfo.id) : [];
    // Same rule as the sidebar's Joined list: memberships granted silently on opening a
    // public space (custom.autoJoined) are not joins, so the menu shows "Join Space" for them.
    this.joinedChannelNames = memberships
      ?.filter((m: any) => m.custom?.autoJoined !== true)
      .map((m: any) => m.channel.id) ?? [];
    this.getFavouriteChannelsInMainContent();

    this.route.paramMap.subscribe(async params => {
      // ngOnInit only runs once per component instance, but switching
      // between spaces re-fires this callback without ngOnInit - re-check
      // token freshness here too, or a session left idle (tab backgrounded,
      // machine asleep) between space switches keeps using a token that
      // went stale while nothing was watching.
      await new Promise<void>(resolve => {
        this.pubnubService.connect(this.currentUserId, () => resolve());
      });
      this.pubnubService.disconnect(this.channelsUrlsList);
      this.channelId = params.get('channelId') || '';
      this.closeSidenav();
      await this.getBlockedUsers();
      this.getOrgChannelById();
    });

    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
      this.addStyles();
      // this.addTooltipStyle();
    });
    this.orgIdSubscription = this.commanSubscribeService.getOrgIdInfo().subscribe(async (response) => {
      this.organizationId = response;
      await this.getBlockedUsers();


    });
    this.organizationId = this.commanSubscribeService.orgId;
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    // this.addTooltipStyle();
    this.settingsData?.bg_secondary_color && document.documentElement.style.setProperty('--bg-secondary-color', this.settingsData.bg_secondary_color);
    this.settingsData?.form_font_secondary_color && document.documentElement.style.setProperty('--mdcmenu_color', this.settingsData?.form_font_secondary_color);
    setTimeout(() => {
      this.connectReportChannels(this.organizationId + '.reported-users');
      this.connectReportChannels(this.organizationId + '.reported-channels');
    }, 3000);

  }
  ngAfterViewInit() {
    const scrollColor = this.settingsData?.form_bg_secondary_color;
    const scrollBackcolor = this.settingsData?.form_bg_primary_color;
    if (this.scrollElement && (scrollColor || scrollBackcolor)) {
      this.scrollElement.nativeElement.style.setProperty('--scroll-color', scrollColor);
      this.scrollElement.nativeElement.style.setProperty('--scroll-backcolor', scrollBackcolor);
    }
  }

  addTooltipStyle() {
    if (this.settingsData?.space_bg_secondary_color) {
      document.documentElement.style.setProperty('--tooltip-bg-color', this.settingsData.space_bg_secondary_color);
    }
    if (this.settingsData?.space_font_secondary_color) {
      document.documentElement.style.setProperty('--tooltip-font-color', this.settingsData.space_font_secondary_color);
    }
    if (this.settingsData?.space_font_primary_color) {
      document.documentElement.style.setProperty('--placeholder-color', this.settingsData?.space_font_primary_color);
    }
  }

  connectReportChannels(channelName: string) {
    this.pubnubService.connect(this.currentUserId, (success, error) => {
      if (error) {
        console.error("Error while connecting to report channel", error);
        return;
      }
      this.pubnubService.enterChannel(channelName, 1, (name, error) => {
        if (error) {
          console.error("Error while entering report channel", error);
          return;
        }
        this.pubnubService.receiveReactions(channelName, (reaction) => {
          if (channelName === `${this.organizationId}.reported-users` && reaction?.data?.type == "block") {
            this.getBlockedUsers();
          } else if (reaction?.data?.type == "block") {
            this.checkChannelStatus(reaction.event === "removed");
          }
        });
      });
    });
  }

  addStyles() {
    const elements = document.getElementsByClassName('mat-mdc-menu-content');
    const elements1 = document.getElementsByClassName('mat-mdc-menu-panel');
    if (elements.length > 0 && this.settingsData?.subs_bg_primary_color) {
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        element.style.setProperty('background-color', this.settingsData?.space_bg_primary_color, 'important');
        element.style.setProperty('color', this.settingsData?.space_font_main_color, 'important');
        element.style.setProperty('font-family', this.settingsData?.font_family, 'important');
      }
    }
    const element_item = document.getElementsByClassName('mat-mdc-menu-item');
    if (element_item.length > 0 && this.settingsData?.font_secondary_color) {
      for (let i = 0; i < element_item.length; i++) {
        const element = element_item[i] as HTMLElement;
        element.style.setProperty('color', this.settingsData?.font_secondary_color, 'important');
      }
    }
    // if (this.settingsData?.space_bg_secondary_color) {
    //   console.log("tooltip true")
    //   document.documentElement.style.setProperty('--tooltip-bg-color', this.settingsData.space_bg_secondary_color);
    // }
    // if (this.settingsData?.space_font_secondary_color) {
    //   document.documentElement.style.setProperty('--tooltip-text-color', this.settingsData.space_font_secondary_color);
    // }
    if (this.settingsData?.font_family) {
      document.documentElement.style.setProperty('--app-font', this.settingsData.font_family);
    }
  }
  get menuActions() {
    this.actions = [
      {
        label: 'View Details', icon: 'info', handler: () => {
          this.openSidenav()
        }
      },
    ];

    if (this.channelDetails?.createdBy?.split('_')[1] !== this.userInfo.id) {
      if (!this.channelDetails?.isJoined) {
        this.actions.push({ label: 'Join Space', icon: 'group_add', handler: () => { this.joinChannel("Join Space") } });
      } else {
        const canLeave = this.channelDetails?.channelVisibility === 'public';
        this.actions.push(canLeave
          ? { label: 'Leave Space', icon: 'logout', handler: () => { this.joinChannel("Leave Space") } }
          : { label: 'Joined', icon: 'check', handler: () => { this.joinChannel("Joined") } });
      }
      this.actions.push(
        {
          label: this.channelDetails?.isStarred ? 'Starred' : 'Star',
          icon: 'star',
          handler: () => {
            !this.channelDetails?.isStarred ? this.addFavouriteChannel() : this.removeFavouriteChannel()
          }
        },
        { label: 'Report Space', icon: 'report', handler: () => { this.reportChannel() } }
      );
    }

    return this.actions;
  }
  async getOrgChannelById() {
    this.channelsUrlsList = [];
    this.isCheckingChannel = true;
    let url = API.GET_ORG_COMMUNITY_CHANNEL;
    this.loader.start();
    this.isJoinedChannel = localStorage.getItem('isJoinedChannel');
    this.appTVService.getBaseRequest(`${url}/${this.channelId}`).subscribe(async result => {
      if (result?.pubnubId) {
        this.channelUrl = result?.pubnubId;
        this.channelDetails = result;
          console.log("Space network_group_id:", this.channelDetails.networkGroupId);

        // This session's token was minted before this org's context (and
        // possibly before an approval just granted this fan membership to
        // this channel) existed. Without this refresh, the cached token
        // never picks up either until the fan logs out and back in.
        if (result?.organizationId) {
          this.commanSubscribeService.getPubnubToken(result.organizationId);
        }

        this.commanSubscribeService.sendSpaceDetails(this.channelDetails);
        if (this.channelUrl && this.joinedChannelNames.includes(this.channelUrl)) {
          this.channelDetails.isJoined = true;
        } else {
          this.channelDetails.isJoined = this.isJoinedChannel;
        }

        if (result.id && this.favData.some((fav: any) => fav.channelId === result.id)) {
          this.channelDetails.isStarred = true;
        } else {
          this.channelDetails.isStarred = false;
        }

        if (this.isJoinedChannel) {
          this.pubnubService.getLastReadTimetoken(this.channelUrl).then(token => {
            this.lastReadTimetoken = token;
          });
        }

        this.channelDetails.privateChannelUsers.forEach(user => {
          let userInfo = user.userInfo;
          user.nickname = userInfo && userInfo.lastName ? `${userInfo.firstName} ${userInfo.lastName}` : userInfo?.firstName;
          if (!user.nickname) {
            user.nickname = userInfo && userInfo.lastname ? `${userInfo.firstname} ${userInfo.lastname}` : userInfo?.firstname;
          }
          user.userColor = this.getColor(user.userId);
          user.shortName = this.getName(user.nickname);
        });
        const members: any = await this.pubnubService.getChannelMembers({}, this.channelDetails);
        this.channelDetails.memberCount = Array.isArray(members?.data) ? members?.data?.length : 0;
        this.filteredTeamMembers = this.channelDetails.privateChannelUsers;
        await this.ensurePublicChannelMembership();
        this.checkChannelStatus(true);
      } else {
        this.isChannelAvailable = false;
        this.isCheckingChannel = false;
        this.loader.stop();
      }
    }, error => {
      this.loader.stop();
    })
  }

  checkChannelStatus(connect?: boolean) {
    this.loader.start();
    let URL = API.GET_REPORT_CHANNELS;
    let payload = {
      organizationId: this.organizationId,
      channelUrl: this.channelUrl
    }
    this.appTVService.postBaseRequest(URL, payload).subscribe((res) => {
      let channelsData = res?.data?.data;
      const matchedChannel = channelsData?.find((channel: any) => this.channelUrl === channel.channelUrl);
      if (matchedChannel?.isBlocked) {
        this.isBlockedChannel = true;
        this.isCheckingChannel = false;
      } else {
        this.isBlockedChannel = false;
        if (connect) {
          this.connectChannels(this.channelUrl);
        } else {
          this.pubnubService.disconnect(this.channelsUrlsList);
        }
      }
      this.loader.stop();
    });
  }

  getBlockedUsers() {
    if (this.organizationId) {
      this.blockedUsersData = [];
      this.loader.start();
      let URL = API.GET_REPORT_USERS;
      let payload = {
        organizationId: this.organizationId
      }
      this.appTVService.postBaseRequest(URL, payload).subscribe((res) => {
        this.loader.stop();
        let usersData = res?.data?.data;
        this.blockedUsersData = usersData?.filter((user: any) => user.isBlocked).map((user: any) => user.userId);
        const matchedUser = usersData.find((user: any) => 'fan_' + this.userInfo.id === user.userId);
        this.commanSubscribeService.sendUserCommunityStatus(matchedUser?.isBlocked === true);
      });
    }
  }

  onTypeSearch(e) {
    this.filteredTeamMembers = this.channelDetails?.privateChannelUsers.filter(user => user.nickname.toLowerCase().includes(e.toLowerCase()));
    this.cdRef.detectChanges();
  }

  selectMessage(message: any) {
    if (this.emojiMsgId) {
      return;
    }
    this.selectedMsg = this.selectedMsg?.messageId === message?.messageId ? null : message;
    this.emojiMsgId = null;
  }

  selectThreadMessage(message: any) {
    if (this.emojiMsgId) {
      return;
    }
    this.selectedThreadMsg = this.selectedThreadMsg?.messageId === message?.messageId ? null : message;
    this.emojiMsgId = null;
  }

  get combinedThreadMessages(): any[] {
    return [this.threadMessage, ...(this.threadMessage.threadReplies || [])];
  }

  getEmojiKeys(reactions: any): string[] {
    // console.log("reactions", reactions);
    return reactions ? Object.keys(reactions) : [];
  }

  openCloseEmoji(messageId: number, fromThread?: boolean) {
    this.emojiMsgId = this.emojiMsgId === messageId ? null : messageId;
    this.displayEmojiPicker = fromThread ? false : true;
  }

  private handleLocalReactionUpdate(
    messageId: string,
    emoji: string,
    userDetails: any
  ): void {
    const message = this.getMessageById(messageId);
    if (!message) return;


    const existingEmoji = Object.keys(message.reactions || {}).find(e =>
      message.reactions[e].users.some(u => u.userId === this.currentUserId)
    );

    // Remove existing emoji from UI
    if (existingEmoji) {
      this.updateMessageReactions({
        event: 'removed',
        data: { value: JSON.stringify({ emoji: existingEmoji, ...userDetails }) }
      }, true);
    }

    // Stop if user clicked same emoji again (untoggle)
    if (existingEmoji != emoji) {
      // Add new emoji
      this.updateMessageReactions({
        event: 'added',
        data: { value: JSON.stringify({ emoji, ...userDetails }) }
      }, true);
    }
  }

  addEmoji(messageTimetoken: any, messageId: any, emojiEvent?: any, isThread?: boolean) {

    this.emojiMsgId = null;
    let emoji = emojiEvent?.emoji ? emojiEvent.emoji.native : emojiEvent;
    const userDetails = {
      userId: this.currentUserId,
      nickname: this.userInfo.user_display_name,
      messageId,
      profileUrl: this.userInfo.profile_pic || ''
    }

    this.handleLocalReactionUpdate(messageId, emoji, userDetails);

    this.pubnubService.sendMessageReaction(!isThread ? this.channelUrl : this.threadChannelUrl, messageTimetoken, emoji, userDetails, (status, response) => {
      if (status.error) {
        console.error('Error sending reaction:', status);
      }
    });
  }
  // Public channels have no PAM grant path that doesn't require an actual
  // PubNub membership record - the "Join Space" action (joinChannel() below)
  // grants that, but it's an explicit menu click, and a fan opening a
  // public channel for the first time (e.g. from Trending) never sees a
  // prompt to click it first. Silently grant membership here instead, so
  // opening any public channel Just Works, the way it would if the fan had
  // already joined - no toast, no analytics event, since the fan didn't
  // take a deliberate "join" action.
  private async ensurePublicChannelMembership() {
    if (this.channelDetails?.channelVisibility !== 'public') return;
    try {
      const memberships = await this.pubnubService.getMemberships(this.currentUserId);
      const alreadyMember = memberships.some((m: any) => m.channel.id === this.channelUrl);
      if (alreadyMember) return;
      const result = await this.pubnubService.setMemberships(this.channelDetails, true);
      const joined = result?.some((item) => item.channel?.id === this.channelDetails?.pubnubId);
      if (joined) {
        // Read/post access only: isJoined stays false until the fan clicks Join Space
        // or posts (sendMessage() then makes it a real join), matching the sidebar.
        // Awaited (unlike joinChannel()'s fire-and-forget refreshToken() call
        // below) so the caller's subsequent enterChannel()/subscribe attempt
        // uses the refreshed token on its first try, instead of relying on
        // enterChannel()'s own retry-after-denial fallback to catch it.
        await new Promise<void>((resolve) => this.pubnubService.refreshToken(this.currentUserId, () => resolve()));
      }
    } catch (error) {
      console.error('Failed to auto-join public channel:', error);
    }
  }

  // Public spaces only: a private space's access exists solely through its
  // membership, so leaving one would lock the fan out of the page they are on.
  private async leaveChannel() {
    if (this.channelDetails?.channelVisibility !== 'public') return;
    const left = await this.pubnubService.removeMembership(this.channelDetails.pubnubId);
    if (!left) {
      this.toastr.error("Failed to leave the space");
      return;
    }
    this.channelDetails.isJoined = false;
    this.joinedChannelNames = this.joinedChannelNames.filter((name) => name !== this.channelUrl);
    this.toastr.success("You left the space");
    // Drops the write grant the membership carried; reading continues
    // through the public-channel pattern grant.
    this.pubnubService.refreshToken(this.currentUserId);
    this.pubnubService.getChannelMembers({}, this.channelDetails);
    this.appTVService.triggerRefresh();
  }

  async joinChannel(status: string) {
    const userStatus = status === "Join Space" ? "Joining the community channel" : "Leaving the community channel";
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`${userStatus}: ${channelName} and the id is ${channelId} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `${userStatus}: ${channelName} and the id is ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'community-channel-joined'
    }

    this.commanSubscribeService.sendTriggeredEvent(u_payload);
    if (status === "Leave Space") {
      await this.leaveChannel();
      return;
    }

    const customMetadata = {
      joined_at: new Date().toISOString(),
      nickname: this.userInfo.user_display_name,
      role: 'Member'
    }
    const url = environment.PUBNUB_API_URL + API.PUBNUB_JOIN;
    const payload = {
      pubNubUserId: this.currentUserId,
      channelUrl: this.channelUrl
    };
    // this.appTVService.pubnubpostBaseRequest(url, payload).subscribe(result => {

    //   if (result.status === 200) {
    //     this.channelDetails.isJoined = true;
    //     this.menuActions;
    //     this.toastr.success("Joined the space successfully");
    //     this.appTVService.triggerRefresh();
    //   }else{
    //     this.toastr.error("Failed to join the space ");
    //   }

    // }, error => {
    //   console.log(error);
    // })
    // this.pubnubService.updateMemberships(customMetadata, this.channelDetails).then(() => {
    // })
    const memberships = await this.pubnubService.getMemberships(this.currentUserId);
    // A membership already existing isn't the same thing as the fan having
    // explicitly joined - opening a public space auto-grants one silently
    // (see ensurePublicChannelMembership()) so they can read/post right
    // away. Without checking autoJoined specifically, clicking "Join Space"
    // after merely having opened the channel would see "already a member"
    // and skip calling setMemberships() entirely - silently doing nothing.
    const existingMembership = memberships.find(
      (m: any) => m.channel.id === this.channelUrl
    );
    const alreadyExplicitlyJoined = !!existingMembership && existingMembership.custom?.autoJoined !== true;
    if (!alreadyExplicitlyJoined) {
      const result = await this.pubnubService.setMemberships(this.channelDetails);
      const joined = result?.some(
        (item) => item.channel?.id === this.channelDetails?.pubnubId
      );
      if (joined) {
        this.channelDetails.isJoined = true;
        if (!this.joinedChannelNames.includes(this.channelUrl)) {
          this.joinedChannelNames.push(this.channelUrl);
        }
        this.toastr.success("Joined the space successfully");
        // The token's write grant for this channel only exists once
        // generateToken() re-scans memberships and picks up the one we
        // just created above - without refreshing now, posting a message
        // right after joining would still 403 until the periodic refresh.
        this.pubnubService.refreshToken(this.currentUserId);
      }
    }

    this.pubnubService.getChannelMembers(customMetadata, this.channelDetails);
    this.appTVService.triggerRefresh();
  }


  getFavouriteChannelsInMainContent() {
    if (this.currentUserId) {
      const url = API.GET_ALL_FAVOURITE_CHANNELS;
      const data = {
        dataStatus: "A",
        userId: this.currentUserId,
        pageNumber: 0,
        limit: 0
      };

      this.appTVService.postBaseRequest(url, data).subscribe(
        (result) => {
          this.favData = result?.data || [];

        },
        (err) => {
          console.error("Error fetching favourite channels in maincontent:", err);
          this.isFavourite = false;
        }
      );
    }
  }
  addFavouriteChannel() {
    const url = API.ADD_FAVOURITE_CHANNEL;
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Community channel is added to Favorites: ${channelName} ${channelId} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Community channel is added to Favorites: ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'starred'
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    const payload = {
      channelId: this.channelId,
      userId: this.currentUserId
    };
    this.favChannelRecordId = payload.userId;
    this.appTVService.postBaseRequest(url, payload).subscribe(
      (result) => {
        if (result?.id) {
          this.toastr.success("Space added to favourites.");
          this.channelDetails.isStarred = true;
          this.getFavouriteChannelsInMainContent();
          // this.channelDetails.isJoined=false;
          this.appTVService.triggerRefresh();
        }
      },
      (error) => {
        const isDuplicateError = error?.error?.includes?.('Unique constraint');
        if (isDuplicateError) {
          this.removeFavouriteChannel();
          // this.toastr.success("Channel removed from favourites.");
          this.appTVService.triggerRefresh();
        } else {
          this.toastr.error("Failed to add to favourites.");
        }
      }
    );
  }
  removeFavouriteChannel() {
    const favItem = this.favData.find((item: any) => item.channelId === this.channelId);
    const favId = favItem?.id;
    const url = API.REMOVE_FAVOURITE_CHANNEL + '/' + favId;
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Community channel is removed from Favorites: ${channelName} ${channelId} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Community channel is removed from Favorites: ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId  || null,

      clickAction: 'unstarred'
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);
    // this.appTVService.deleteBaseRequest(url,'fan_'+this.userInfo.id).subscribe(
    //   (result:any) => {
    //     console.log("result111",result)
    //     if (result) {
    //       this.toastr.success("Space removed from favourites.");
    //       this.channelDetails.isStarred=false;
    //       this.appTVService.triggerRefresh();
    //     }
    //   },
    // );
    this.appTVService.deleteBaseRequest(url, 'fan_' + this.userInfo.id).subscribe({
      next: (result: any) => {
        if (result) {
          this.toastr.success("Space removed from favourites.");
          this.channelDetails.isStarred = false;
          this.getFavouriteChannelsInMainContent();
          this.appTVService.triggerRefresh();
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 201) {
          this.toastr.success("Space removed from favourites.");
          this.channelDetails.isStarred = false;
          this.getFavouriteChannelsInMainContent();
          this.appTVService.triggerRefresh();
        } else {
          console.error("API failed", url, error);
        }
      }
    });
  }
  reportChannel() {
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Clicked on Report channel: ${channelName} ${channelId}- ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Clicked on Report channel: ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'report-channel'
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      width: '500px',
      data: { isReportChannel: true, settingsData: this.settingsData }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const url = API.REPORT_CHANNEL;
        this.loader.start();
        const username = 'fan_' + this.userInfo.id;
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const accessToken = userInfo.accessToken;
        const payload = {
          organizationId: this.organizationId,
          channels: [
            {
              channelUrl: this.channelUrl,
              reason: result.reason,
              description: result.description,
              displayName: this.channelDetails.channelName,
              reportedBy: this.currentUserId,
              reportedByName: this.userInfo.user_display_name,
              channelOwner: this.channelDetails.createdBy,
            }
          ]
        };
        this.appTVService.postBase1Request(url, payload, username, accessToken).subscribe((result: any) => {
          this.loader.stop();
          if (result?.data) {
            this.toastr.success("Space reported successfully.");
          }
          // this.appTVService.triggerRefresh();
        });

      }
    });

  }

  reportContent(msg: any, isThread?: boolean) {
    this.emojiMsgId = null;
    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      width: '500px',
      data: { isReportUser: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.start();
        let messagePayload: any = {
          type: "report",
          message: msg.type == 'poll' ? msg.question : msg.message,
          customType: 'COMMUNITY_CHAT',
          messageId: uuidv4(),
          timestamp: Date.now(),
          files: msg.files,
          _sender: {
            userId: msg._sender.userId,
            nickname: msg._sender.nickname,
          },
          reportDetails: {
            reportedBy: this.currentUserId,
            reporterName: this.userInfo.user_display_name,
            reason: result.reason,
            description: result.description
          },
          parentMessageId: msg.messageId,
          parentTimetoken: msg.timetoken,
          channelUrl: isThread ? this.threadChannelUrl : this.channelUrl
        };
        this.pubnubService.sendMessage(this.organizationId + '_reports_channel', messagePayload, (status, res) => {
          this.loader.stop();
          if (status.error) {
            console.log("Error while reporting message", status.error);
            this.toastr.error("Error while reporting message");
          } else {
            this.toastr.success('Message reported successfully');
          }
        });
      }
    });
  }


  createPoll() {
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Poll icon is clicked: ${channelName} ${channelId}- ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Poll icon is clicked: ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'poll-clicked'
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      width: '500px',
      data: { isPoll: true, settingsData: this.settingsData }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.start();

        const options: string[] = result.options;
        const formattedOptions: any[] = options.map((opt, index) => ({
          id: index.toString(),
          option: opt
        }));

        const votesPerOption: Record<string, number> = {};
        formattedOptions.forEach(opt => {
          votesPerOption[opt.id] = 0;
        });
        const pollData = {
          type: "poll",
          question: result.question,
          totalVotes: 0,
          userVote: {},
          options: formattedOptions,
          votesPerOption: votesPerOption,
          isAllowMultipleResponses: result.allowMultiple,
          messageId: uuidv4(),
          timestamp: Date.now(),
          publishAt: 'fan_' + this.userInfo.id,
          _sender: {
            isSender: true,
            profileUrl: this.userInfo.profile_pic || '',
            userId: 'fan_' + this.userInfo.id,
            nickname: this.userInfo.user_display_name
          },
          pn_gcm: {
            'notification': {
              'title': 'New message in ' + this.channelDetails.channelName,
              'body': result.question,
            },
            'data': {
              'channel_id': this.communityChannel,
              'type': 'poll',
              'user_id': this.currentUserId,
              'channel_name':this.channelDetails?.channelName,
              'channel_type': this.channelDetails?.channelVisibility,
              'is_my_channel': this.channelDetails?.createdBy === 'fan_'+this.userInfo?.id ? 'true' : 'false',
              'isFromThreadsScreen': this.threadMessage?._sender?.isSender ? 'true' : 'false',
              'network_name': this.router.url.split("/")[1],
              'space_id': this.channelDetails?.id || '',
            },
          }
        }
        console.log("pollData",pollData);

        this.pubnubService.createPoll(this.channelUrl, pollData, (status, response) => {
          if (status.error) {
            console.error("Failed to create poll:", status);
          } else {
            console.log("Poll created successfully:", response);
            this.showOwnPoll(pollData, response?.timetoken);
          }
        });
        this.loader.stop();
      }
    });

  }
  // Same as sendMessage(): the sender's own poll is added locally once PubNub confirms the
  // publish, instead of relying on the live listener (which skips duplicates by messageId).
  // The publish timetoken is required for voting on it straight away.
  private showOwnPoll(pollData: any, timetoken: any) {
    if (this.messagesList.some(m => m.messageId === pollData.messageId)) return;
    const { pn_gcm, ...poll } = pollData;
    poll._sender = { ...poll._sender, userColor: this.getColor(poll._sender.userId), shortName: this.getName(poll._sender.nickname) };
    this.messagesList.push({
      ...poll,
      timetoken,
      msgTime: this.formatTime(poll.timestamp),
      sentMsg: true,
      messageType: 'messageBox',
    });
    this.cdRef.detectChanges();
    setTimeout(() => this.setScrollBottom('channel-inner-box'), 100);
  }

  // The sender edits their own message: shown at once, then stored as an 'edit' message action
  // on the channel the message was published to (a thread's first message lives in the main channel).
  saveEdit(message: any, text: string) {
    const newText = (text || '').trim();
    if (!message?.sentMsg || !newText || newText === message.message || !message.timetoken) return;
    const channel = this.messagesList.includes(message) ? this.communityChannel : this.threadChannelUrl;
    const previous = { message: message.message, editedAt: message.editedAt };
    message.message = newText;
    message.editedAt = Date.now() * 10000;
    this.pubnubService.editMessage(channel, message.timetoken, message.messageId, newText, (status, response) => {
      if (status?.error) {
        Object.assign(message, previous);
        this.toastr.error("Couldn't save your edit. Please try again.");
      } else if (response?.data?.actionTimetoken) {
        message.editedAt = Number(response.data.actionTimetoken);
      }
    });
  }

  getMessageById(messageId: string) {
    return this.messagesList.find(msg => msg.messageId === messageId) || this.messagesList.reduce((acc, msg) => acc || msg.threadReplies?.find(reply => reply.messageId === messageId), null);
  }

  //   updateMessageReactions(reaction: any, ownReaction?: boolean) {
  //     const parsedReaction = JSON.parse(reaction.data.value);
  //     console.log("updateMessageReaction-reaction",reaction,parsedReaction);
  //     const { emoji, userId, nickname, profileUrl } = parsedReaction;
  // console.log("updateMessageReaction-parsedReaction",emoji, userId, nickname, profileUrl);

  //     // Skip if already optimistically handled
  //     if (userId ==='fan_' +this.currentUserId && !ownReaction) {
  //       return;
  //     }
  //     const message = this.getMessageById(parsedReaction.messageId);
  //     if (message) {
  //       let userDetails: any = { userId, nickname, profileUrl };
  //       const reactionEvent = reaction.event;
  //       userDetails.userColor = this.getColor(userDetails.userId);
  //       userDetails.shortName = this.getName(userDetails.nickname);

  //       if (!message.reactions) {
  //         message.reactions = {};
  //       }

  //       if (!message.reactions[emoji]) {
  //         message.reactions[emoji] = { count: 0, users: [] };
  //       }

  //       if (reactionEvent === 'added') {
  //         message.reactions[emoji].count += 1;
  //         message.reactions[emoji].users.push(userDetails);
  //       } else {
  //         message.reactions[emoji].count -= 1;
  //         message.reactions[emoji].users = message.reactions[emoji].users.filter(user => user.userId !== userDetails.userId);
  //         if (message.reactions[emoji].count === 0) {
  //           delete message.reactions[emoji];
  //         }
  //       }
  //     }
  //   }

  updateMessageReactions(reaction: any, ownReaction?: boolean) {
    try {
      const parsedReaction = JSON.parse(reaction.data.value);
      const messageId = parsedReaction.messageId;
      const userId = parsedReaction.userId;
      const message = this.getMessageById(messageId);
      // Handle Poll Vote
      // Skip if this is already handled by the user (optimistic UI)
      if (userId === this.currentUserId && !ownReaction) {
        return;
      }
      if (reaction.data.type === 'poll') {
        this.handleVote(message, parsedReaction.optionId, userId);
        return;
      }


      if (!message) {
        console.warn("No message found for reaction:", messageId);
        return;
      }

      // Handle Emoji
      const { emoji, nickname, profileUrl, timestamp } = parsedReaction;
      const userDetails: any = {
        userId,
        nickname,
        profileUrl,
        timestamp: Number(timestamp),
        userColor: this.getColor(userId),
        shortName: this.getName(nickname)
      };

      if (!message.reactions) {
        message.reactions = {};
      }

      // Step 1: Remove previous emoji from this user, if any
      for (const key of Object.keys(message.reactions)) {
        const existing = message.reactions[key];

        const userIndex = existing.users.findIndex(u => u.userId === userId);

        if (userIndex !== -1) {
          // If same emoji: toggle it (remove)
          if (key === emoji) {
            existing.users.splice(userIndex, 1);
            existing.count--;

            if (existing.count === 0) {
              delete message.reactions[key];
            }

            return; // exit early since it was a toggle
          } else {
            // Different emoji: remove the old one
            existing.users.splice(userIndex, 1);
            existing.count--;

            if (existing.count === 0) {
              delete message.reactions[key];
            }
          }
        }
      }
      // Step 2: Add the new emoji
      if (!message.reactions[emoji]) {
        message.reactions[emoji] = { count: 0, users: [] };
      }

      message.reactions[emoji].count += 1;
      message.reactions[emoji].users.push(userDetails);

    } catch (error) {
      console.error("Error in updateMessageReactions:", error);
    }
  }

  handleVote(poll: any, optionId: string, userId: string) {
    poll.userVote = poll.userVote || {};
    poll.votesPerOption = poll.votesPerOption || {};
    poll.totalVotes = poll.totalVotes || 0;

    const isMultiple = poll.isAllowMultipleResponses;
    poll.userVote[userId] = poll.userVote[userId] || [];
    const currentVotes = poll.userVote[userId];

    if (!isMultiple) {
      if (currentVotes.includes(optionId)) return;
      if (currentVotes.length > 0) {
        const previousOption = currentVotes[0];
        poll.votesPerOption[previousOption] = (poll.votesPerOption[previousOption] || 1) - 1;
        poll.totalVotes--;
      }

      currentVotes.length = 0;
      currentVotes.push(optionId);
      poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
      poll.totalVotes++;
    } else {
      if (currentVotes.includes(optionId)) {
        const index = currentVotes.indexOf(optionId);
        currentVotes.splice(index, 1);
        poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 1) - 1;
        poll.totalVotes--;
      } else {
        currentVotes.push(optionId);
        poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
        poll.totalVotes++;
      }
    }

    poll.userVote[userId] = currentVotes;
  }

  connectChannels(channelUrl: string, threadMsg?: any) {
    this.pubnubService.connect(this.currentUserId, (success, error) => {
      if (error) {
        this.isChannelAvailable = false;
        this.isCheckingChannel = false;
        this.loader.stop();
        return;
      } else {
        this.pubnubService.enterChannel(channelUrl, 1, (channelName, error) => {
          this.isCheckingChannel = false;
          if (error) {
            this.isChannelAvailable = false;
            console.log("Error while entering community channel", error);
            this.loader.stop();
            return;
          }
          this.isChannelAvailable = true;
          if (!this.channelsUrlsList.includes(channelName)) {
            this.channelsUrlsList.push(channelName);
          }
          if (!threadMsg) {
            this.communityChannel = channelName;
            this.loadMessages(this.communityChannel);
          } else {
            this.loadMessages(channelName, threadMsg);
          }
        })
      }
    });
  }

  handleKeyDown(event: KeyboardEvent, isThread?: boolean) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage(isThread);
    }
  }

  adjustTextareaHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  onScroll(containerId: string) {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.autoScroll(containerId);
    }, 150);
  }

  autoScroll(containerId: string) {
    let div = document.getElementById(containerId);
    if (!div) return;
    const isAtBottom = Math.abs(div.scrollHeight - div.scrollTop - div.clientHeight) < 5;
    // Scroll to bottom only if user is already at the bottom    
    if (div && isAtBottom) {
      setTimeout(() => this.setScrollBottom(containerId), 100);
    }
  }

  setScrollBottom(containerId: string, isInitialLoad?: boolean) {
    var div = document.getElementById(containerId);
    const unreadEl = document.getElementById('unread-start-point');
    if (div) {
      if (isInitialLoad && unreadEl) {
        $(`#${containerId}`).animate({
          scrollTop: unreadEl.offsetTop - div.offsetTop
        }, 500);
      } else {
        this.removeUnreadMarker();
        this.favChannelIds = this.favData.map((ch: any) => ch.channelId);
        if (this.isJoinedChannel) {
          this.pubnubService.updateLastReadTimetoken(this.channelUrl);
        }
        $(`#${containerId}`).animate({
          scrollTop: div.scrollHeight - div.clientHeight
        }, 500);
      }
    }
  }

  formatTime(messageId): string {
    return new Date(messageId).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
  loadMessages(channelUrl: string, threadMsg?: any) {
    let newMsgsStartPoint = false;
    this.pubnubService.getAllMessage(channelUrl, 100, (messagesList, status) => {
      const targetList = threadMsg ? (threadMsg.threadReplies || (threadMsg.threadReplies = [])) : this.messagesList;
      targetList.length = 0;
      this.loader.stop();

      if (status.error) {
        console.log("Error while loading messages", status.error);
        return;
      }
      // Helper function to process messages and replies
      const processMessage = (msg) => {
        let message = { ...msg.entry, timetoken: msg.timetoken, reactions: msg.reactions, isThreadInitiated: msg.isThreadInitiated, isBlocked: msg.isBlocked };
        if (msg.reactions) {
          Object.keys(msg.reactions).forEach(emoji => {
            msg.reactions[emoji].users = msg.reactions[emoji].users.map(user => ({
              ...user,
              userColor: this.getColor(user.userId),
              shortName: this.getName(user.nickname)
            }));
          });
        }
        if (msg.isThreadInitiated) {
          this.connectChannels(this.channelUrl + message.messageId, message);
        }
        if (parseInt(msg.entry.timestamp) > parseInt(this.lastReadTimetoken) && !newMsgsStartPoint && !threadMsg && this.isJoinedChannel) {
          message.newMsgsStartPoint = true;
          newMsgsStartPoint = true;
        }
        if (message._sender) {
          let nicknameParts = message._sender.nickname?.split(" ") || [];
          message._sender.nickname = nicknameParts.length > 1 && nicknameParts[1]?.toLowerCase() !== "null"
            ? `${nicknameParts[0]} ${nicknameParts[1]}`
            : nicknameParts[0];

          message._sender.userColor = this.getColor(message._sender.userId);
          message._sender.shortName = this.getName(message._sender.nickname);
        }

        message.msgTime = this.formatTime(message.timestamp);
        // if(message.type === 'poll') {
        //   message.sentMsg = 'fan_' + this.currentUserId === message._sender?.userId;
        // }
        // else{
        //   message.sentMsg = this.currentUserId === message._sender?.userId;
        // }
        message.sentMsg = this.currentUserId === message._sender?.userId;
        Object.defineProperty(message, 'blockedUser', {
          get: () => this.blockedUsersData?.includes(message._sender?.userId)
        });
        // Process replies
        // message.threadReplies = message.replies.map(processMessage);
        // delete message.replies;
        return message;
      };

      targetList.push(...messagesList.map(processMessage)); // Update the array in place
      setTimeout(() => {
        this.setScrollBottom(threadMsg ? "thread-inner-box" : "channel-inner-box", true);
      }, 100);
    });

    this.pubnubService.receiveMessages(channelUrl, (msg) => {
      let channel = msg.subscribedChannel;
      if (!channel || !this.channelsUrlsList.includes(channel)) return;

      let message = { ...msg.message, timetoken: msg.timetoken };

      // Helper function to format message details
      const formatMessageDetails = (message) => {
        if (message._sender?.nickname) {
          let [firstName, lastName] = message._sender.nickname.split(" ");
          message._sender.nickname = lastName?.toLowerCase() !== "null" ? `${firstName} ${lastName}` : firstName;
        }
        message._sender.userColor = this.getColor(message._sender.userId);
        message._sender.shortName = this.getName(message._sender.nickname);
        message.msgTime = this.formatTime(message.timestamp);
        // if(message.type === 'poll') {
        //   message.sentMsg = 'fan_' + this.currentUserId === message._sender?.userId;
        // }
        // else{
        //   message.sentMsg = this.currentUserId === message._sender?.userId;
        // }
        message.sentMsg = this.currentUserId === message._sender?.userId;
        message.messageType = "messageBox";
        return message;
      };
      let targetList = threadMsg ? threadMsg?.threadReplies : this.messagesList;
      let isUniqueMessage = !targetList?.some(m => m.messageId === message.messageId);
      if (isUniqueMessage && targetList) {
        targetList.push(formatMessageDetails(message));
        if (message._sender.userId === this.currentUserId) {
          setTimeout(() => this.setScrollBottom(threadMsg ? "thread-inner-box" : "channel-inner-box"), 100);
        } else {
          this.autoScroll(threadMsg ? "thread-inner-box" : "channel-inner-box");
        }
      }
    });


    this.pubnubService.receiveReactions(channelUrl, (reaction) => {
      if (reaction?.data?.type == "reaction" || reaction?.data?.type == "poll") {
        this.updateMessageReactions(reaction);
      } else if (reaction?.data?.type == "thread") {
        const parsedReaction = JSON.parse(reaction.data.value);
        let message = this.getMessageById(parsedReaction.messageId);
        if (message && !message.isThreadInitiated) {
          message.isThreadInitiated = true;
          this.connectChannels(this.channelUrl + parsedReaction.messageId, message);
        }
      } else if (reaction?.data?.type == "block") {
        const parsedReaction = JSON.parse(reaction.data.value);
        let message = this.getMessageById(parsedReaction.messageId);
        message.isBlocked = reaction.event === "added";
      } else if (reaction?.data?.type == EDIT_ACTION_TYPE && reaction.event === "added") {
        const parsedEdit = JSON.parse(reaction.data.value);
        applyMessageEdit(this.getMessageById(parsedEdit.messageId), reaction.data.uuid, parsedEdit.text, Number(reaction.data.actionTimetoken));
      }
    });
  }

  isUserInvolvedInThread(threadMsg: any): boolean {
    let isInvolved = threadMsg.threadReplies.some(reply => reply._sender?.userId === this.currentUserId)
    threadMsg.threadInvolvement = isInvolved;
    return isInvolved;
  }

  toggleMessage(message: any): void {
    message.isExpanded = !message.isExpanded;
  }

  removeUnreadMarker() {
    const index = this.messagesList.findIndex(m => m.newMsgsStartPoint);
    if (index !== -1) {
      delete this.messagesList[index].newMsgsStartPoint;
    }
  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }


  isOptionSelected(poll: any, optionId: string): boolean {
    const currentUserId = 'fan_' + this.userInfo.id;
    return poll.userVote?.[currentUserId]?.includes(optionId);
  }

  onVoteOptionClick(poll: any, optionId: string, event: Event) {
    const currentUserId = 'fan_' + this.userInfo.id;
    poll.userVote = poll.userVote || {};
    poll.votesPerOption = poll.votesPerOption || {};
    poll.totalVotes = poll.totalVotes || 0;

    poll.userVote[currentUserId] = poll.userVote[currentUserId] || [];
    const currentVotes: any[] = poll.userVote[currentUserId];

    const isMultiple = poll.isAllowMultipleResponses;

    const value = {
      userId: 'fan_' + this.userInfo.id,
      nickname: this.userInfo.user_display_name,
      messageId: poll.messageId,
      profileUrl: this.userInfo.profile_pic || '',
      timestamp: Date.now(),
      optionId: optionId,
    };

    if (!poll.timetoken) return;

    if (!isMultiple) {
      if (currentVotes.includes(optionId)) return;

      if (currentVotes.length > 0) {
        const previousOption = currentVotes[0];
        poll.votesPerOption[previousOption] = (poll.votesPerOption[previousOption] || 1) - 1;
        poll.totalVotes--;
      }

      currentVotes.length = 0;
      currentVotes.push(optionId);
      poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
      poll.totalVotes++;
      // poll.selectedOption = optionId;
    } else {
      if (currentVotes.includes(optionId)) {
        const index = currentVotes.indexOf(optionId);
        currentVotes.splice(index, 1);
        poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 1) - 1;
        poll.totalVotes--;
      } else {
        currentVotes.push(optionId);
        poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
        poll.totalVotes++;
      }
    }
    poll.userVote[currentUserId] = currentVotes;
    this.pubnubService.sendPollVote(poll, this.channelUrl, value, (status, response) => {
      if (status.error) {
        console.error("Error sending poll vote:", status);
      } else {
        console.log("Poll vote sent successfully:", response);
      }
    }); // Your pubnub call
  }



  // onVoteOptionClick(poll: any, optionId: string, event: Event) {
  //   const currentUserId = 'fan_' + this.userInfo.id;

  //   // Make sure each poll has its own vote state
  //   poll.userVote = poll.userVote || {};
  //   poll.votesPerOption = poll.votesPerOption || {};
  //   poll.totalVotes = poll.totalVotes || 0;

  //   // Only reference the current poll's votes
  //   const currentVotes = [...(poll.userVote[currentUserId] || [])];
  //   const isMultiple = poll.isAllowMultipleResponses;

  //   const value = {
  //     userId: currentUserId,
  //     nickname: this.userInfo.user_display_name,
  //     messageId: poll.messageId,
  //     profileUrl: this.userInfo.profile_pic || '',
  //     timestamp: Date.now(),
  //     optionId: optionId,
  //   };

  //   if (!poll.timetoken) return;

  //   if (!isMultiple) {
  //     if (currentVotes.includes(optionId)) 
  //       {
  //       // Unselect
  //       currentVotes.length = 0;
  //       poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 1) - 1;
  //       poll.totalVotes--;
  //     }


  //     // Remove previous vote (if any)
  //     if (currentVotes.length > 0) {
  //       const previousOption = currentVotes[0];
  //       poll.votesPerOption[previousOption] = Math.max((poll.votesPerOption[previousOption] || 1) - 1, 0);
  //       poll.totalVotes--;
  //     }

  //     // Add new vote
  //     poll.userVote[currentUserId] = [optionId];
  //     poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
  //     poll.totalVotes++;

  //   } else {
  //     // Multi-response logic
  //     const index = currentVotes.indexOf(optionId);
  //     if (index > -1) {
  //       currentVotes.splice(index, 1);
  //       poll.votesPerOption[optionId] = Math.max((poll.votesPerOption[optionId] || 1) - 1, 0);
  //       poll.totalVotes--;
  //     } else {
  //       currentVotes.push(optionId);
  //       poll.votesPerOption[optionId] = (poll.votesPerOption[optionId] || 0) + 1;
  //       poll.totalVotes++;
  //     }

  //     poll.userVote[currentUserId] = currentVotes;
  //   }

  //   // PubNub sync
  //   this.pubnubService.sendPollVote(poll, this.channelUrl, value, (status, response) => {
  //     if (status.error) {
  //       console.error("Error sending poll vote:", status);
  //     } else {
  //       console.log("Poll vote sent successfully:", response);
  //     }
  //   });
  // }


  

  async uploadFileOnS3(file): Promise<string> {
    let extension = this.getFileExtension(file.name);
    let channelName = this.channelDetails.channelName.replace(/ /g, '');
    const accessToken = this.userInfo.accessToken;
    let signData = {
      type: this.getFileCategory(file),
      key: `org_${this.organizationId}/communitychannels/${channelName}/${new Date().getTime()}.${extension}`,
      contentType: file.type,
    };
    this.loader.start();
    try {
      const data = await this.appTVService.postBase1Request(`partner/v1/${API.GET_SIGNED_URL}`, signData, this.currentUserId, accessToken).toPromise();
      if (data.status === 0) {
        await this.appTVService.uploadFileAWSS3(data.url, file.type, file).toPromise();
        this.loader.stop();
        return environment.AWS.ACCESS_URL + signData.key;
      } else {
        this.toastr.info(data.message);
        this.loader.stop();
        return "";
      }
    } catch (error) {
      console.log(error);
      this.loader.stop();
      return "";
    }
  }

  

  file_ext = "";
  getFileExtension(name) {
    let getExt = name.split(".");
    this.file_ext = getExt[getExt.length - 1];
    return this.file_ext;
  }

  getFileCategory(file: File): string {
    const mimeType = file.type;
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    if (mimeType.startsWith("audio/")) return "audio";
    return "document"; // Default fallback
  }

  isOnlyEmoji(text: string): boolean {
    const emojiRegex = /^(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F)$/u;
    return emojiRegex.test(text.trim());
  }



  async sendMessage(isThread?: boolean) {
    let inputField = isThread ? this.threadInput : this.userInput;
    let files = isThread ? this.threadSelectedFiles : this.selectedFiles;
    if (!inputField.trim() && files.length == 0) return;

    if (!this.communityChannel || (isThread && !this.threadChannelUrl)) {
      this.toastr.error("Chat channels not connected");
      return;
    }
    const now = new Date();
    const formattedTime = now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
    setTimeout(() => {
      if (isThread) {
        this.threadInput = "";
        this.threadSelectedFiles = [];
      } else {
        this.userInput = "";
        this.selectedFiles = [];
      }
    }, 10);


    // Determine message type and notification body
    const hasFiles = files && files.length > 0;
    let messageType = hasFiles ? "file" : "text";

    let notificationBody = inputField;
    if (hasFiles) {
      // Create file names string
      const fileNames = files.map(file => file.name || 'File').join(', ');

      if (inputField.trim()) {
        // If there's both text and files
        notificationBody = `${inputField} (Files: ${fileNames})`;
      }
      else if (this.isOnlyEmoji(inputField.trim())) {
        messageType = "reaction";
      }
      else {
        // If only files, no text
        notificationBody = fileNames;
      }
    }

    let messagePayload: any = {
      type: "text",
      message: inputField,
      customType: 'COMMUNITY_CHAT',
      userType: "fan",
      messageId: uuidv4(),
      timestamp: now.getTime(),      
      msgTime: formattedTime, 
      files: files,
      sentMsg: true,
      _sender: {
        isSender: true,
        profileUrl: this.userInfo.profile_pic || '',
        userId: this.currentUserId,
        nickname: this.userInfo.user_display_name,
        shortName: this.getName(this.userInfo.user_display_name)
      },
      publishAt: this.currentUserId,
      pn_gcm: {
        'notification': {
          'title': 'New message in ' + this.channelDetails.channelName + (isThread ? ' - Thread' : ''),
          'body': notificationBody,
        },
        'data': {
          'channel_id': !isThread ? this.communityChannel : this.threadChannelUrl,
          'type': messageType,
          'user_id': this.currentUserId,
          'channel_name':this.channelDetails?.channelName,
          'isFromThreadsScreen': isThread ? 'true' : 'false',
          'network_name': this.router.url.split("/")[1],
          'space_id': this.channelDetails?.id || '',
        },
      },
    };

    if (isThread) {
      messagePayload.parentMessageId = this.threadMessage.messageId;
      messagePayload.pn_gcm.data['selected_msg'] = this.threadMessage?.message;
      messagePayload.pn_gcm.data['message_id'] = this.threadMessage?.messageId;
      messagePayload.pn_gcm.data['sender'] = this.threadMessage?._sender?.nickname;
      messagePayload.pn_gcm.data['time'] = this.channelDetails?.createdOn;
    }
    else{
      messagePayload.pn_gcm.data['channel_type'] = this.channelDetails?.channelVisibility;
      messagePayload.pn_gcm.data['is_my_channel'] = this.channelDetails?.createdBy === 'fan_'+this.userInfo?.id ? 'true' : 'false';
    }

    console.log("sendMessage",messagePayload)
    if (isThread) {
      if (!this.threadMessage.threadReplies) {
        this.threadMessage.threadReplies = [];
      }
      const exists = this.threadMessage.threadReplies.some(
        m => m.messageId === messagePayload.messageId
      );
      if (!exists) {
        this.threadMessage.threadReplies.push(messagePayload);
      }
    } else {
      const exists = this.messagesList.some(
        m => m.messageId === messagePayload.messageId
      );
      if (!exists) {
        this.messagesList.push(messagePayload);
      }
    }
    this.cdRef.detectChanges();
    setTimeout(() => {
      const container = document.getElementById(
        isThread ? 'thread-inner-box' : 'channel-inner-box'
      );

      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 200);
    if (this.userInfo.id) {
      if (isThread && !this.threadMessage?.isThreadInitiated) {
        // First reply in a brand-new thread: the thread channel has no PubNub
        // membership yet, so the current token has no grant for it - join it
        // and refresh the token before publishing, or the send would 403.
        await this.pubnubService.joinThreadChannel(this.threadChannelUrl);
        await new Promise<void>((resolve) => {
          this.pubnubService.refreshToken(this.currentUserId, () => resolve());
        });
      } else if (!isThread && !this.channelDetails?.isJoined) {
        // Public channels are browsable without joining (read-only grant),
        // but posting still requires real membership - a fan sending their
        // first message before clicking "Join Space" would otherwise 403.
        // Auto-join here instead, same pattern as the thread case above.
        await this.pubnubService.setMemberships(this.channelDetails);
        await new Promise<void>((resolve) => {
          this.pubnubService.refreshToken(this.currentUserId, () => resolve());
        });
        if (this.channelDetails) {
          this.channelDetails.isJoined = true;
        }
      }
      this.pubnubService.sendMessage(!isThread ? this.communityChannel : this.threadChannelUrl, messagePayload, (status) => {
        if (status.error) {
          this.toastr.error("Error while sending message");
        } else if (isThread && !this.threadMessage?.isThreadInitiated) {
          this.pubnubService.markThreadStarted(this.channelUrl, this.threadMessage.timetoken, this.threadMessage.messageId, this.currentUserId, (status, response) => {
            if (status.error) {
              console.error('Error marking thread as started:', status);
            } else {
              this.threadMessage.isThreadInitiated = true;
            }
          });
        }
      });
    }

  }

  toggleEmojiPicker(isThread?: boolean): void {
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Emoji icon is clicked on ${channelName} and the id is ${channelId}- ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Emoji icon is clicked on ${channelName} and the id is ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'emoji-clicked'
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    if (isThread) {
      this.isThreadEmojiInputVisible = !this.isThreadEmojiInputVisible;
    } else {
      this.isEmojiInputVisible = !this.isEmojiInputVisible;
    }
  }

  getColor(userId) {
    let color = "";
    if (!this.userColor[userId]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[userId] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[userId];
    }
    return color;
  }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  showReactionUsers(emoji: string, message: any, menuTrigger: MatMenuTrigger): void {
    this.addStyles();
    this.hoveredReaction = emoji;
    this.reactionUsers = message.reactions[emoji]?.users || [];
    setTimeout(() => {
      menuTrigger.openMenu();
      setTimeout(() => {
        this.addStyles();
      }, 20);
    }, 100);
  }

  hideReactionUsers(menuTrigger: MatMenuTrigger): void {
    setTimeout(() => {
      menuTrigger?.closeMenu();
    }, 300);
  }

  getFormattedDate(messageId: number): string {
    const date = new Date(messageId);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (this.isSameDate(date, today)) return 'Today';
    if (this.isSameDate(date, yesterday)) return 'Yesterday';

    const diffInDays = Math.floor((today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

    if (diffInDays < 7) {
      return new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);
    }

    return formatDate(date, 'd MMMM yyyy', 'en-US');
  }

  isSameDate(date1: Date, date2: Date): boolean {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  }

  displayDate(index: number): boolean {
    if (index === 0) return true;
    const currentDate = new Date(this.messagesList[index].timestamp);
    const previousDate = new Date(this.messagesList[index - 1].timestamp);
    return !this.isSameDate(currentDate, previousDate);
  }



  async onFileSelected(event: Event, isThread?: boolean) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const filesArray = Array.from(input.files);

      const uploadPromises = filesArray.map(async (file) => {
        const url = await this.uploadFileOnS3(file);
        return {
          url,
          type: this.getFileCategory(file),
          name: file.name
        };
      });

      const uploadedFiles = await Promise.all(uploadPromises);

      if (isThread) {
        this.threadSelectedFiles.push(...uploadedFiles);
      } else {
        this.selectedFiles.push(...uploadedFiles);
      }
    }
  }


  downloadFile(file: any) {
    const downloadUrl = file.url;
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  deleteFileOnS3(fileUrl: string): Promise<void> {
    const url = API.VOD_S3_FILE_DELETE;
    return this.appTVService.postRequest(url, { urls: [fileUrl] }).toPromise().catch((error) => {
      console.error(error);
    });
  }

  removeFile(index: number, isThread?: boolean) {
    const files = isThread ? this.threadSelectedFiles : this.selectedFiles;
    const file = files[index];
    if (file.url) {
      this.deleteFileOnS3(file.url).then(() => {
        files.splice(index, 1);
      }).catch((error) => {
        console.error(error);
      });
    } else {
      files.splice(index, 1);
    }
  }

  reportUser(msg: any, isThread?: boolean) {
    this.emojiMsgId = null;
    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      width: '500px',
      data: { isReportUser: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.start();
        const username = 'fan_' + this.userInfo.id;
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const accessToken = userInfo.accessToken;
        const payload = {
          organizationId: this.organizationId,
          users: [
            {
              userId: msg._sender.userId,
              channelUrl: isThread ? this.threadChannelUrl : this.channelUrl,
              reason: result.reason,
              description: result.description,
              displayName: msg._sender.nickname,
              reportedBy: this.currentUserId,
              reportedByName: this.userInfo.user_display_name
            }
          ]
        };
        this.appTVService.postBase1Request(API.REPORT_USER, payload, username, accessToken).subscribe((result: any) => {
          this.loader.stop();
          if (result?.data) {
            this.toastr.success("User reported successfully.");
          }
        }, error => {
          this.loader.stop();
          console.error(error);
        });
      }
    });
  }

  updateChannel(details: any) {
    let url = API.CREATE_UPDATE_COMMUNITY_CHANNEL;
    let data: any = {
      "id": this.channelDetails.id,
      "organizationId": this.organizationId,
      "teamId": this.channelDetails.teamId,
      "teamName": this.channelDetails.teamName
    }
    if (details.selectedUsers.length > 0) {
      data.channelUsers = details.selectedUsers.map(user => ({
        userId: user.userId,
        pubNubUserId: user.pubNubUserId,
        userInfo: user.personalInfo,
        userType: user.sportsPersonnelType.value.toLowerCase()
      }));
    }
    if (details.removedUsers.length > 0) {
      data.deletedChannelUsers = details.removedUsers.map(user => ({
        userId: user.userId,
        pubNubUserId: user.pubNubUserId,
        userInfo: user.userInfo,
        userType: user.sportsPersonnelType.value.toLowerCase()
      }));
    }
    this.appTVService.postBaseRequest(url, data).subscribe(result => {
      this.toastr.success("Space Updated Successfully");
      //reload the channels data after updating
      this.getOrgChannelById();
    }, error => {
      console.log(error);
    })
  }

  addTeamMember() {
    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      width: '500px',
      data: {
        isAddTeamMember: true,
        teamDetails: { id: this.channelDetails.teamId, usersList: this.channelDetails.privateChannelUsers }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateChannel(result);
      }
    });
  }
  openSidenav(msg?: any) {
    this.threadMessage = msg;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    (window as any).umami?.track(`View details is clicked on ${channelName} with id: ${channelId} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `View details is clicked on ${channelName} with id: ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: `community`
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    this.sidenav.open();
    if (msg) {
      this.threadChannelUrl = this.channelUrl + msg.messageId;
      setTimeout(() => {
        this.setScrollBottom("thread-inner-box");
      }, 100);
    }
  }

  closeSidenav() {
    this.threadMessage = null;
    this.threadChannelUrl = "";
    this.sidenav?.close();
  }

  addEmojiToInput(event: any, isThread: boolean): void {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;

    (window as any).umami?.track(`Emoji is selected on ${channelName} with id: ${channelId} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Emoji is selected on ${channelName} with id: ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: `community`
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    if (isThread) {
      this.threadInput = (this.threadInput || "") + event.emoji.native;
      this.isThreadEmojiInputVisible = false;
      setTimeout(() => {
        this.threadMessageInput.nativeElement.focus();
      }, 0);
    } else {
      this.userInput = (this.userInput || "") + event.emoji.native;
      this.isEmojiInputVisible = false;
      setTimeout(() => {
        this.messageInput.nativeElement.focus();
      }, 0);
    }
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (
      target.tagName === "EMOJI-MART" ||
      target.closest("emoji-mart") ||
      target.classList.contains("emoji-input")
    ) {
      return;
    }
    this.isThreadEmojiInputVisible = false;
    this.isEmojiInputVisible = false;
  }

  hexToRgba(hex: string, opacity: number = 0.5): string {
    if (!hex) return '';
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // getSvgFilter(settingColor:string): string {
  //   const color = settingColor || '#000000';

  //   if (color.toLowerCase() === '#ffffff' || color.toLowerCase() === '#fff' || color.toLowerCase() === '#e3e3e3') {
  //     return 'brightness(0.1) invert(0)';
  //   }else {
  //     return 'brightness(0) invert(1)'; 
  //   }
  // }
  getSvgFilter(settingColor: string): string {
    const hex = settingColor?.toLowerCase() || '#000000';

    const luminance = this.getLuminance(hex);
    if (luminance > 0.9) {
      return 'brightness(0.1) invert(0)';
    }
    return 'brightness(0) invert(1)';
  }

  private getLuminance(hex: string): number {
    if (hex.length === 4) {
      hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance;
  }

  isActionAllowed(label: string): boolean {
    const allowedLabels = ['View Details', 'Report Space'];
    return allowedLabels.includes(label) || !!this.userInfo?.id;
  }

  MemberSearch() {
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Members of channel are searching ${channelName} ${channelId}- ${userId}`)
    const payload = {
      actionType: "community",
      metaData: {
        title: `Members of channel are searching ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction: 'search'
    }
    this.commanSubscribeService.sendTriggeredEvent(payload);
  }

  activeBlock: string = '';

  async sendTips() {
    const channelName = this.channelDetails.channelName;
    const channelId = this.channelDetails.id;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Tips icon is clicked: ${channelName} ${channelId}- ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Tips icon is clicked: ${channelName} ${channelId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,
      clickAction: 'tips-clicked'
    };
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    this.userService.sendStatus(false);
    this.userService.showActiveStreamBlock.next('Tips');
    const performer_id = this.commanSubscribeService.perfomerInfoData.data.Data[0].performer_id;

    try {
      const athletesResponse = await this.getAtheletsData();
      if (!athletesResponse?.length) {
        this.toastr.error('No Sports personnel are available');
        return;
      }
      let data = {
        user_id: this.userInfo.id,
        organization_id: this.organizationId,
        //stream_id: 23477,
        redirectUrl: this.router.url,
        paymentType: 'community_tip',
        performer_id: performer_id,
        organisationNetworkData: this.commanSubscribeService.currentNetworkData,
        spaceDetails: this.commanSubscribeService.spaceDetails,
        network_group_id: this.channelDetails?.networkGroupId || null
      };
      this.commanSubscribeService.sendPaymentInfo(data);
      const dialogRef = this.dialog.open(CommunityTipsComponent, {
        width: '500px', 
        height: '500px', 
        panelClass: 'tips-dialog-container', 
        data: {'isFromCommunityTips': true,settingsData: this.settingsData} 
        
      });

      console.log("Dialog opened for tips");

      dialogRef.afterClosed().subscribe(result => {
        console.log('The tips dialog was closed');
      });
    } catch (error) {
      console.error("Failed to load athletes data:",error);
    }

  }

  getAtheletsData(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = environment.API_URL_TV_BASE + API.GET_ATHLETS_DATA;
      const orgId = this.organizationId;

      this.appPaymentService.postUrlRequest(url, { organizationId: orgId, search: "", dataStatus: 'A', networkGroupId: this.channelDetails?.networkGroupId || null }).subscribe(result => {
        const apiResponse = result.data;
        this.athletesData.push(apiResponse);
        this.commanSubscribeService.saveAthletesData(this.athletesData);
        resolve(apiResponse);
      }, error => {
        reject(error);
      });
    })

  }

  shareSpace(channelData:any){
    if(this.channelDetails?.id === channelData?.id){
      this.channelDetails.socialShareClick = true;
    }else{
      this.channelDetails.socialShareClick = false;
    }
  }

  closeSocialSharePopup(e) {
    if (e == true) {
      if (this.channelDetails) {
        this.channelDetails.socialShareClick = false;
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickout() {
    if (this.channelDetails) {
      this.channelDetails.socialShareClick = false;
    }
  }
  ngOnDestroy() {
    this.pubnubService.disconnect(this.channelsUrlsList);
    if (this.joinedChannelsSub) {
      this.joinedChannelsSub.unsubscribe();
    }
  }
}




